export const CATEGORY_IDS = {
  ANIME: "15",
  STAGE: "16",
  SFX: "17",
  KIDS: "18",
  MOVIE: "19",
  DRAMA: "20",
  DMM_TV_ORIGINAL: "21",
  VARIETY: "22",
  GRAVURE: "23",
  PPV: "ppv",
  SPECIAL: "special",
  ENTERTAINMENT: "entertainment",
} as const;

type CategoryIds = typeof CATEGORY_IDS;
export type CategoryId = CategoryIds[keyof CategoryIds];

export const CATEGORIES = [
  {
    id: CATEGORY_IDS.ANIME,
    name: "アニメ",
    priority: 1,
    queryParam: "anime",
  },
  {
    id: CATEGORY_IDS.STAGE,
    name: "2.5次元・舞台",
    priority: 2,
    queryParam: "stage",
  },
  {
    id: CATEGORY_IDS.SFX,
    name: "特撮",
    priority: 3,
    queryParam: "sfx",
  },
  {
    id: CATEGORY_IDS.KIDS,
    name: "キッズ",
    priority: 4,
    queryParam: "kids",
  },
  {
    id: CATEGORY_IDS.DMM_TV_ORIGINAL,
    name: "DMM TVオリジナル",
    priority: 5,
    queryParam: "original",
  },
  {
    id: CATEGORY_IDS.MOVIE,
    name: "映画",
    priority: 6,
    queryParam: "movie",
  },
  {
    id: CATEGORY_IDS.DRAMA,
    name: "ドラマ",
    priority: 7,
    queryParam: "drama",
  },
  {
    id: CATEGORY_IDS.VARIETY,
    name: "バラエティ",
    priority: 8,
    queryParam: "variety",
  },
  {
    // NOTE: idはnullですが判別用にppv入れとく
    id: CATEGORY_IDS.PPV,
    name: "レンタル・購入",
    priority: 9,
    queryParam: "ppv",
  },
  {
    id: CATEGORY_IDS.GRAVURE,
    name: "グラビア",
    priority: 10,
    queryParam: "gravure",
  },
] as const;
